import React, { Component } from 'react';
import { getNetwork, isDefaultNetwork } from 'app/scripts/services/app-state';
import cloudinary from 'app/scripts/utils/cloudinary';

class LoginPageLogo extends Component {
  render() {
    var network = getNetwork();
    var src = cloudinary.url(network.imageId, { height: 96, width: 96 });
    var component = null;
    if (isDefaultNetwork()) {
      src = 'https://publisher-assets.spot.im/host-panel/openweb-circle-logo.png';
      component = (
        <a className="logo-container" href="http://openweb.com" target="_blank">
          <img className="login-logo" src={src} />
        </a>
      );
    } else {
      component = (
        <div className="logo-container">
          <img className="login-logo" src={src} />
        </div>
      );
    }

    return component;
  }
}

LoginPageLogo.displayName = 'LoginPageLogo';

export default LoginPageLogo;
